import React from 'react';

const WalletIcon = () => (
  <svg
    width={58}
    height={65}
    viewBox="0 0 58 65"
    fill="none"
    className="wallet-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x={1.146} y={1.629} width={46.642} height={51.086} rx={9} fill="#27282D" stroke="#8D6752" strokeWidth={2} />
    <rect x={1.146} y={9.482} width={55.708} height={53.938} rx={9} fill="#27282D" stroke="#8D6752" strokeWidth={2} />
    <circle cx={41.857} cy={24.745} r={6.263} fill="#8D6752" />
  </svg>
);

export default WalletIcon;
